import * as util from "./util";
import axios from 'axios'
import qs from 'qs'

export default fetch => {
  return {
    async info() {
      const { data } = await fetch.get(`//${window.$bili_arcopen.isUAT ? 'uat-' : ''}api.bilibili.com/x/web-interface/nav`)
      if (data.code === 0 && data.data && data.data.isLogin) {
        return data.data
      } else {
        return null
      }
    },
    async getArcUserInfo () {
      const { data } = await fetch.get('/arcopen/user/account/info')
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    async logout() {
      const { data } = await axios.post(`//${window.$bili_arcopen.isUAT ? 'uat-' : ''}passport.bilibili.com/login/exit/v2`, qs.stringify({
        biliCSRF: util.getCookie('bili_jct')
      }), {
        withCredentials: true
      })

      if (data.code === 0) {
        location.reload()
      } else {
        throw new Error('登出失败')
      }
    },
    async passportInfo() {
      const { data } = await fetch.get(`//${window.$bili_arcopen.isUAT ? 'uat-' : ''}passport.bilibili.com/web/site/user/info`)
      if (data.code === 0) {
        return data.data
      } else {
        return null
      }
    },
    async getMessage () { // 我的消息
      const { data } = await fetch.get('/arcopen/user/msg/cnt')
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
    async getMessageList (params) { // 站内信列表
      const { data } = await fetch.get('/arcopen/user/msg/list', {params})
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error(data.message)
      }
    },
  }
}
